module.exports = __webpack_public_path__ + "img/product-atomizer-kangertech-KR30000.52d712ae.jpg";